const tokenKey = "admin_token";
const sessionTokenKey = "admin_token_session";

export const getAdminToken = () => {
  return localStorage.getItem(tokenKey) || sessionStorage.getItem(sessionTokenKey) || "";
};

export const setAdminToken = (token: string, remember = true) => {
  if (remember) {
    localStorage.setItem(tokenKey, token);
    sessionStorage.removeItem(sessionTokenKey);
    return;
  }
  sessionStorage.setItem(sessionTokenKey, token);
  localStorage.removeItem(tokenKey);
};

export const clearAdminToken = () => {
  localStorage.removeItem(tokenKey);
  sessionStorage.removeItem(sessionTokenKey);
};
